import angular from "angular";
import PayPalVaultCard from "./PayPalVaultCard.vue";
import Vue from "vue";
import "ngVue";

export default angular
  .module("directives.paypalvaultcard", [])
  .directive("dcPaypalVaultCard", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(Vue.component("DcPaypalVaultCard", PayPalVaultCard));
    },
  ]);
